import './HeroWithTechnologies.scss';

class HeroWithTechnologies {

  constructor(node) {
    this.node = node;
  }

  init() {
    //console.log();
  }

}

JSModules['HeroWithTechnologies'] = HeroWithTechnologies;
export default HeroWithTechnologies;
